"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var react_1 = __importDefault(require("react"));
var system_1 = require("../../system");
var Input_1 = require("./Input");
var styles_1 = require("./styles");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    textarea: function (props) { return ({
        padding: (0, styles_1.getPaddings)(props),
    }); },
    textareaInput: {
        '$textarea &': {
            padding: '0 !important',
        },
    },
    helperNode: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    lengthProgress: function (_a) {
        var error = _a.error;
        return ({
            color: error
                ? theme.go.schemes.colors.system.TextAttention
                : theme.go.schemes.colors.system.TextMinor,
        });
    },
}); });
function TextareaComponent(_a) {
    var maxLength = _a.maxLength, helperText = _a.helperText, value = _a.value, _b = _a.InputProps, InputProps = _b === void 0 ? {} : _b, props = __rest(_a, ["maxLength", "helperText", "value", "InputProps"]);
    var _c = useStyles({
        error: props.error,
        iconStart: false,
        disabled: props.disabled,
        clearable: props.clearable,
        variant: system_1.InputVariants.Frame,
    }), helperNode = _c.helperNode, lengthProgress = _c.lengthProgress, textarea = _c.textarea, textareaInput = _c.textareaInput;
    var inputProps = maxLength ? { maxLength: maxLength } : undefined;
    var helperTextNode = (react_1.default.createElement("span", { className: helperNode },
        react_1.default.createElement("span", null, helperText || ''),
        react_1.default.createElement("span", { className: lengthProgress }, maxLength ? "".concat((value === null || value === void 0 ? void 0 : value.length) || 0, "/").concat(maxLength) : '')));
    return (react_1.default.createElement(Input_1.Input, __assign({}, props, { value: value, helperText: helperTextNode, inputProps: inputProps, variant: system_1.InputVariants.Frame, InputProps: __assign({ classes: __assign({ root: textarea, input: textareaInput }, InputProps.classes) }, InputProps), multiline: true })));
}
exports.Textarea = react_1.default.memo(TextareaComponent);
